var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.481,
    height: 16.096,
    viewBox: "0 0 19.481 16.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#25282e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.195,45.683a1.357,1.357,0,0,0-1.059-.5H14.381l-2.035-4.567a.557.557,0,0,0-.313-.3.587.587,0,0,0-.439.008.555.555,0,0,0-.3.737l1.835,4.119H6.346l1.835-4.119a.555.555,0,0,0-.3-.737.587.587,0,0,0-.439-.008.557.557,0,0,0-.313.3L5.1,45.185H1.348a1.357,1.357,0,0,0-1.059.5,1.269,1.269,0,0,0-.256,1.1l2,8.583a1.332,1.332,0,0,0,1.315,1.017h12.78a1.332,1.332,0,0,0,1.311-1.021l2-8.583a1.269,1.269,0,0,0-.256-1.1Zm-3.062,9.573H3.352a.2.2,0,0,1-.2-.148l-2-8.583a.168.168,0,0,1,.035-.148.209.209,0,0,1,.166-.076H4.6l-.149.335a.555.555,0,0,0,.3.737.578.578,0,0,0,.752-.289l.349-.783h7.791l.349.783a.578.578,0,0,0,.752.289.555.555,0,0,0,.3-.737l-.149-.335h3.254a.209.209,0,0,1,.166.076.169.169,0,0,1,.035.148l-2,8.583a.2.2,0,0,1-.2.148Z",
    transform: "translate(0 -40.283)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M151.581,266.717a.557.557,0,0,0-.581.529v3.88a.583.583,0,0,0,1.162,0v-3.88A.557.557,0,0,0,151.581,266.717Z",
    transform: "translate(-145.262 -258.551)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.581,266.717a.557.557,0,0,0-.581.529v3.88a.583.583,0,0,0,1.162,0v-3.88A.557.557,0,0,0,241.581,266.717Z",
    transform: "translate(-231.841 -258.551)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M331.581,266.717a.557.557,0,0,0-.581.529v3.88a.583.583,0,0,0,1.162,0v-3.88A.557.557,0,0,0,331.581,266.717Z",
    transform: "translate(-318.419 -258.551)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCart);
export default __webpack_public_path__ + "static/media/new-cart.6d30ae0150b23c7e56ae163bd9adafef.svg";
export { ForwardRef as ReactComponent };